import * as React from 'react';
import {ToastContext} from 'utilities/toasts';

import {useToastManager} from '../utilities/toasts/useToastManager';

export const Toast = ({children}: {children: React.ReactNode}) => {
  const toastManager = useToastManager();

  return (
    <ToastContext.Provider value={toastManager}>
      {children}
    </ToastContext.Provider>
  );
};
